/**
 * @file 配置控制
 * @author mengchen <mengchen@babytree-inc.com>
 */

const getHostEnv = function() {
  const { host } = location;
  if (host == 'h5-fe-shop.meitun.com') {
    return 'online';
  }
  // pre
  if (host.indexOf('pre.fpm') > -1) {
    return 'pre';
  }
  // test
  if (host.indexOf('-test') > -1) {
    return 'test';
  }
  return 'local';
};

export const processEnv = {
  nodeEnv: process.env.NODE_ENV,
  buildVersion: process.env.BUILD_VERSION,
  hostEnv: getHostEnv()
};

export const getStorePrefix = function() {
  return '@@babytree-shop-';
};

export function getGOHost() {
  // online
  if (processEnv.hostEnv == 'online') {
    return '//go.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv == 'pre') {
    return '//go.pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv == 'test') {
    return '//go.1.babytree-test.com/';
  }
  // local
  return '//go.1.babytree-test.com/';
}

export function getPHPHost() {
  // online
  if (processEnv.hostEnv == 'online') {
    return '//api.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv == 'pre') {
    return '//api.pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv == 'test') {
    return '//21.babytree-test.com/';
  }
  // local
  return '//21.babytree-test.com/';
}

export function getNewMapHost() {
  // online
  if (processEnv.hostEnv == 'online') {
    return '//newmapi.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv == 'pre') {
    return '//newmapi.babytree.com/';
  }
  // test
  if (processEnv.hostEnv == 'test') {
    return '//newmapi.babytree-test.com/';
  }
  // local
  return '//newmapi.babytree-test.com/';
}

export function getMapiWebHost() {
  // online
  if (processEnv.hostEnv == 'online') {
    return '//mapiweb.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv == 'pre') {
    return '//mapiweb.pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv == 'test') {
    return '//mapiweb.babytree-test.com/';
  }
  // local
  return '//mapiweb.babytree-test.com/';
}

export function getABTestingHost() {
  // online
  if (processEnv.hostEnv == 'online') {
    return '//abtesting.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv == 'pre') {
    return '//abtesting.babytree.com/';
  }
  // test
  if (processEnv.hostEnv == 'test') {
    return '//abtesting.babytree.com/';
  }
  // local
  return '//abtesting.babytree.com/';
}

export function getOpenHost() {
  // online
  if (processEnv.hostEnv == 'online') {
    return '//open.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv == 'pre') {
    return '//open-21.babytree-test.com/';
  }
  // test
  if (processEnv.hostEnv == 'test') {
    return '//open-21.babytree-test.com/';
  }
  // local
  return '//open-21.babytree-test.com/';
}

export function getMeitunHost() {
  // online
  if (processEnv.hostEnv == 'online') {
    return '//m.meitun.com/';
  }
  // pre
  if (processEnv.hostEnv == 'pre') {
    return '//m.meitun.com/';
  }
  // test
  if (processEnv.hostEnv == 'test') {
    return '//m.meitun-test.com/';
  }
  // local
  return '';
  return '//m.meitun-test.com/';
}

export function getWebviewHost() {
  // online
  if (processEnv.hostEnv == 'online') {
    return '//webview.babytree.com/';
  }
  // pre
  if (processEnv.hostEnv == 'pre') {
    return '//pre.fpm.babytree.com/';
  }
  // test
  if (processEnv.hostEnv == 'test') {
    return '//webview.21.babytree-test.com/';
  }
  // local
  return '//webview.21.babytree-test.com/';
}

// 站外
export const QUERY_KEY_WHITE_MAP = {
  'babytree-app-id': 1,
  'babytree-app-latitude': 1,
  'babytree-app-longitude': 1,
  'babytree-app-mac': 1,
  'babytree-app-version': 1,
  'babytree-client-type': 1,
  'bpreg-brithday': 1,
  bpreg_brithday: 1,
  'client-baby-status': 1,
  'client-role': 1,
  'enc-user-id': 1,
  'babytree-app-device-model': 1,
  'current-baby-id': 1,
  prepare_status: 1,
  'android-id': 1,
  'babytree-app-imei': 1,
  tool_id: 1,
  idfa: 1,
  moblie_share_src: 1,
  share_pregst: 1,
  share_dest: 1,
  share_ts: 1,
  share_uid: 1,
  share_bd: 1,
  navigation_bar_hidden: 1,
  forbid_scroll: 1,
  debug: 1,
  fosun: 1, // 链接上打标区分是否是星喜来源
  tcode: 1,
  request_id: 1,
  group_request_id: 1,
  abtest_id: 1,
  follow_id: 1,
  extra_info: 1
};

// 站内
export const NEWVIEW_QUERY_KEY_WHITE_MAP = {
  navigation_bar_hidden: 1,
  forbid_scroll: 1,
  off_line: 'h5_fe_shop',
  tcode: 1,
  request_id: 1,
  group_request_id: 1,
  abtest_id: 1,
  follow_id: 1,
  extra_info: 1
};

export const NEW_WEBVIEW_QUERY = 'babytree-fe-webview';

window.__processEnv = processEnv;
